module.exports = __webpack_public_path__ + "img/ouverture_dialog.16880ca2.png";